import { createDraftSafeSelector } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { SupportPanelStateType } from '../reducer/supportPanel.reducer'

const state = (state: RootState) => state.supportPanelStore as SupportPanelStateType

export const selectSupportView = createDraftSafeSelector(state, (s) => s.view)
